module.exports = __webpack_public_path__ + "static/media/event_intrusion_detection.7c705019.svg";